
import helpers from '../helpers'

const processors = {

  adv_screen_assets (asset) {
    const partner_id = this.$store.state.users[0].partner_id
    if (asset.asset_type === 'file') {
      asset.asset_file_link_full = config.assets.fsLink + partner_id + '/' + asset.asset_link
    }

    return asset
  },

  payments: function (payment) {
    helpers.joinProductLink(payment)

    payment.fee = payment.requested_amount - payment.original_amount

    payment.assets = _.map(payment.assets, (a) => _.isString(a) ? JSON.parse(a) : a)
    payment.assets = _.sortBy(payment.assets || [], 'asset_id')
    payment.assets = _.map(_.compact(payment.assets), item => {
      if (!item.asset_id) return null;
      helpers.joinAssetUrl(item, 300)
      if (item.asset_url) item.asset_url += '?id=' + item.asset_id
      return item
    })

    helpers.joinCustomerImage(payment)

    helpers.joinFormattedTime.bind(this)(payment, { dateOnly: true }) // join additionally date

    return payment
  },

  payment_children: function (payment) {
    helpers.joinProductLink(payment)

    payment.fee = payment.requested_amount - payment.original_amount

    payment.assets = _.map(payment.assets, (a) => _.isString(a) ? JSON.parse(a) : a)
    payment.assets = _.sortBy(payment.assets || [], 'asset_id')
    payment.assets = _.map(_.compact(payment.assets), item => {
      if (!item.asset_id) return null;
      helpers.joinAssetUrl(item, 300)
      if (item.asset_url) item.asset_url += '?id=' + item.asset_id
      return item
    })

    helpers.joinCustomerImage(payment)

    helpers.joinFormattedTime.bind(this)(payment, { dateOnly: true }) // join additionally date

    return payment
  },

  third_party_payments: function (payment) {
    const app = _.find(this.$store.state.apps, {app_id: payment.app_id});
    payment.app = app || {};
    if (!app) console.error(`Open Maya Payment: App${payment.appid} info not found for payment ${payment.payment_id}`);
    return payment;
  },

  products: function (item) {
    helpers.joinProductLink(item);
    const app = _.find(this.$store.state.apps, {app_id: item.app_id});
    item.app_guid = _.get(app, 'app_guid', '');

    return item;
  },

  categories: function (item) {
    helpers.joinProductLink(item)
    return item
  },


  // device_coins (item) {
  //   const {device_id} = item
  //   const updated = _.cloneDeep(item)
  //
  //   const index = _.findIndex(this.$store.state.devices, {device_id})
  //
  //   if (index === -1) {
  //     return item
  //   } else {
  //     deviceCoins.bind(this)(updated, true)
  //     this.$store.commit('updateRecordInCollection', {collection: 'devices', index, object: {...updated, id: device_id}})
  //     return item
  //   }
  // },

  device_dispenser (item) {
    item.total = item.count_load * item.denomination
    item.inCassette = item.count_caset * item.denomination
    item.inReject = item.count_reject * item.denomination
    helpers.joinFormattedAmounts(item, ['total', 'inCassette', 'inReject'])

    return item
  },

  sso_django_user (item) {
    helpers.joinUserDisplayName(item)

    return item
  },

  clerks (item) {
    helpers.joinUserDisplayName(item)

    return item
  },

  devices_kiosk(item) {
    const modelName = (_.find(this.$store.state.device_models, {model_id: item.model_id}) || {}).name
    item.model_name = modelName

    return item
  },

  sessions(item) {
    helpers.formatSessionDuration(item);
    return item;
  },

  sessions_1w(item) {
    helpers.formatSessionDuration(item);
    return item;
  },

}

class DataProcessor {
  constructor (store) {
    this.$store = store
  }

  process (collection, item) {
    const { $store } = this
    if (!['payments', 'payment_children', 'sessions', 'third_party_payments'].includes(collection)) {
      if (!['payment_assets', 'payment_assets_id', 'receipts', 'sessions_1w', 'sessions'].includes(collection)) helpers.joinSession(item, $store)
      helpers.joinPayment(item, $store)
    }

    if (collection !== 'devices') {
      helpers.joinDevice.bind(this)(item)
    }
    if (collection !== 'locations') helpers.joinLocation(item, $store)
    if (collection !== 'partners') helpers.joinPartnerName(item, $store)

    this.processCollection(collection, item)

    helpers.joinFormattedTime.bind({ $store })(item)

    helpers.joinFormattedAmounts(item)

    return item
  }

  processCollection (name, item) {
    if (processors[name]) {
      processors[name].bind(this)(item)
    }

    return item
  }

}

export default DataProcessor



// WEBPACK FOOTER //
// ./src/store/dataProcessor.js